import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TARGETING_COMMON_KEY } from '../../constants';

@Component({
  selector: 'ca-not-targeted-info-popover',
  templateUrl: './not-targeted-info-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NotTargetedInfoPopoverComponent {
  localizationKey: string = TARGETING_COMMON_KEY;
}
